// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.v-input--is-readonly .v-chip {\n  opacity: 1 !important; \n  background: #e0e0e0 !important;\n  color: rgba(0, 0, 0, 0.87) !important;\n}\n", ""]);
// Exports
module.exports = exports;
